import React from 'react';
import { Modal, Button } from 'antd';
import './confirmModal.css';

const confirm = Modal.confirm;

const showConfirm = (title = '', content = '', onConfirm = () => { }) => {
    confirm({
        title: title,
        content: content,
        onOk() {
            onConfirm()
        },
        okText: "Confirmar",
        cancelText: "Cancelar",
    });
}


export default showConfirm


// WEBPACK FOOTER //
// ./src/App/components/confirmModal/confirmModal.js